// central.eu — SPA entrypoint.
// Bootstraps dees-domtools (theme manager, smartrouter, GDPR cookie consent) and
// mounts the <ceu-app> root; all views and styles live in TypeScript components.

import '@consent.software/catalog';
import * as domtools from '@design.estate/dees-domtools';
import './elements/ceu-app.js';

void domtools.DomTools.setupDomTools();
